import React from "react";
import FullScreenSection from "./FullScreenSection";
import { Box, Heading } from "@chakra-ui/react";
import Card from "./Card";

const projects = [
  {
    title: "Space.io",
    description:" A real-time multiplayer 3D io mobile game with Unity and Photon Fusion",
    getImageSrc: () => require("../videos/spaceio.mp4"),
    url: 'https://play.google.com/store/apps/details?id=com.md89.space.io',
  },
   {
    title: "Mastermind",
    description:" A mobile clone of classical board game Mastermind with Unity. Available on Google Play.",
    getImageSrc: () => require("../videos/Mastermind.mp4"),
    url: 'https://play.google.com/store/apps/details?id=com.md89.mastermind',
  },
  {
    title: "Unity Prototoypes",
    description:
      "Links and repositories of my Unity prototypes. Architectural Rendering, Warehouse Simulator, Sumo, Platformer etc...",
    getImageSrc: () => require("../images/unity.mp4"),
    url: 'https://github.com/mdogan89/UnityProjects',
  },
  {
    title: "Web Projects",
    description:
      "Different full-stack web projects. Little Lemon Restaurant and Netflix clone etc...",
    getImageSrc: () => require("../images/web.mp4"),
    url: 'https://github.com/mdogan89/web-projects',
  }
];

const ProjectsSection = () => {
  return (
    <FullScreenSection
      backgroundColor="#0D1B2A"
      isDarkBackground
      py={{ base: 16, md: 24 }}
      px={{ base: 5, md: 8 }}
      alignItems="flex-start"
      spacing={8}
    >
      <Heading as="h2" id="projects-section">
        Featured Projects
      </Heading>
      <Box
        width="100%"
        display="grid"
        gridTemplateColumns={{ base: "1fr", md: "repeat(2,minmax(0,1fr))" }}
        gridGap={{ base: 5, md: 7 }}
      >
        {projects.map((project) => (
          <Card
            key={project.title}
            title={project.title}
            description={project.description}
            imageSrc={project.getImageSrc()}
            url={project.url}
          />
        ))}
      </Box>
    </FullScreenSection>
  );
};

export default ProjectsSection;
